export const showPricesRetailerSide = 'show-prices-retailer-side';
export const tempHideHasPricePricingFilterSupplierIds = 'temp-hide-pricing-has-price-supplier-ids';
export const enableAnalyticsByUser = 'ui-analytics-by-user';
export const tiktokToggleConnectionStatus = 'tiktok_toggle_connection_status_dev_11404';
export const inventoryHistoryLogInitiatorFlag = 'inventory_history_log_initiator';
export const checkRequiredConfigurations = 'ui_check_missing_configurations_dev_11367';
export const aiChatbot = 'ai-chatbot-dev-10945';

export const enableVariantBufferByUser = 'variant_buffer_by_user_dev_11853';
export const enableVariantBufferBySupplier = 'variant_buffer_by_supplier_dev_11853';

export const enableInventoryManualUpdateWithPopupBySupplier = 'inventory_manual_update_by_supplier_dev_12392';
export const enableInventoryManualUpdateByFileBySupplier =
  'inventory_manual_update_with_file_upload_by_supplier_dev_11905';
export const enableInventoryManualUpdateByFileByEmail = 'inventory_manual_update_with_file_upload_by_email_dev_11905';

export const permittedUserRolesToEditInventoryQuantitiesViaPopup =
  'permitted_user_roles_to_edit_inventory_quantities_via_popup_dev-13170';

export const editVariantBufferByFileUpload = 'edit_variant_buffers_by_file_upload_dev-11777';

export const enableReportsManager = 'ui_reports_manager_dev_10871';
export const enableProductsFeedBySupplier = 'products-feed-by-supplier';
export const enableUploadProductsBySupplier = 'ui_upload_products_by_supplier_dev_12604';
export const enableUploadProductsInCatalogueManagementBySupplier =
  'ui_upload_products_in_catalogue_management_by_supplier_dev_12712';

export const hideRefundTotalWhenNotRefunded = 'hide_refund_total_when_not_refunded_dev_13036';
